import { ITextAreaFormControlOptions } from "..";
import { _SSControlOptionsBase } from "./types/_ss-control-options-base";
import { FormControlOptionsUtils } from "./utils/form-control-options-utils";

export class SSTextAreaOptions implements _SSControlOptionsBase<'textarea'> {

  constructor(
    private _initialOptions?: ITextAreaFormControlOptions
  ) {

    this._initOptions()
  }

  private _initOptions() {

    FormControlOptionsUtils.initMappedObject<'textarea'>(this, this._initialOptions);
  }

  dispose() {

  }
}
